export default __webpack_public_path__ + "static/media/aboutus.35c80a20.png";